import React from 'react'
import { Box, Text } from '@usap/uicomponents'

import warranty from '../../../../config/warranty'
import commaSeparetedValue from '../../../../helpers/commaSeparetedValue'

import {
    PartNoBox,
    ItemTotalBox,
    ItemTotalValue,
    ShippingMethodValue,
    ProductNameBox,
} from './InformationWMO.css'
import { useUnfoldedShippingCookie } from '@usap/carparts/src/shared/hooks/useUnfoldedShipping'

const orderItemShippingMethodV2 = (method, variation, config) => {
  if (method === 'Ground' || method === 'Ground_unfolded') {
    const label = config?.label?.variations.find(v => v.variationValue === variation)
    if (label && method === 'Ground' && label?.foldedLabel) {
      return label.foldedLabel
    } else if (label && method === 'Ground_unfolded' && label?.unfoldedLabel) {
      return label.unfoldedLabel
    }

    return method
  }

  const methods = {
    FDXOVR: 'Next Business Day',
    FDX2ND: '2nd Business Day',
    FDX: 'Standard',
  }

  return methods[`${method}`] || method
}

const Information = ({
    vehicle,
    product,
    core,
    formatBrand,
    isDesktop,
    isMembershipItem,
    unfoldedShippingConfig,
}) => {
    const colorDarkSecondary = props => props.theme.global.colors['darkSecondary'];
    const warrantyLabel = product.warrantyCode && warranty[product.warrantyCode]
        ? warranty[product.warrantyCode]
        : ''
    const unitPrice = commaSeparetedValue(product.itemTotalUnitPrice)
    const unitPricePerEach = product.qty > 1
        ? ` ($${commaSeparetedValue(product.regularPrice)} each)`
        : ''

    const hasWarranty = Boolean(product.itemTotalWarranty) &&
    Number(product.itemTotalWarranty) !== 0 &&
    typeof product.productProtection === 'undefined'
    const warrantyPrice = commaSeparetedValue(product.itemTotalWarranty)
    const warrantyPriceEach = product.qty > 1 ? ` ($${commaSeparetedValue(product.cpp)} each)` : ''

    const unfoldedShippingVariation = useUnfoldedShippingCookie()
    const shippingVariant = product?.packagingVariant &&
      product?.packagingVariant?.trim() !== '' &&
      product?.packagingVariant !== 'a' ?
        product?.packagingVariant : unfoldedShippingVariation
    let shippingMethodCode = product?.shippingMethodCode

    if (
      product?.shippingMethodCode?.toLowerCase() === 'standard'
    ) {
      const packagingState = product?.packagingState?.toLowerCase() || ''
      const packagingVariant = product?.packagingVariant?.toLowerCase() || ''
      if (
        packagingState?.trim() === '' && packagingVariant?.trim() !== ''
      ) {
        shippingMethodCode = 'Ground'
      } else if (packagingState === 'unfolded') {
        shippingMethodCode = 'Ground_unfolded'
      } else if (packagingState === 'folded') {
        shippingMethodCode = 'Ground'
      }
    }

    return (
        <>

            <ProductNameBox direction='row'>
                {product.brand && (
                    <Text weight={600} size={isDesktop ? '16px' : '14px'} color="dark-2">
                        {formatBrand(product.brand)}&nbsp;
                        <Text size={isDesktop ? '16px' : '14px'} color="dark-2" weight={400}>
                            {product.title}
                        </Text>
                    </Text>
                )}
            </ProductNameBox>

            {!isMembershipItem &&
            <>
                <PartNoBox>
                    <Text size="xsmall" color={colorDarkSecondary} truncate>
                        {`Part Number: ${product.partNumber}`}
                    </Text>
                </PartNoBox>

                <Box>
                    <Text size="xsmall" color={colorDarkSecondary} truncate>
                        {`Unit Price: $${unitPrice}${unitPricePerEach}`}
                    </Text>
                </Box>
                {product.shippingMethodCode && (
                    <Box
                      direction={isDesktop ? "row" : "column"}
                      align="flex-start"
                      data-testid="order-details-item-shipping-method"
                    >
                        <Text size="xsmall" color={colorDarkSecondary}>
                            {'Shipping Method:'}&nbsp;
                        </Text>
                        <ShippingMethodValue size="xsmall" color={colorDarkSecondary}>
                            {
                              orderItemShippingMethodV2(
                                shippingMethodCode,
                                shippingVariant,
                                unfoldedShippingConfig
                              )
                            }
                        </ShippingMethodValue>
                    </Box>
                )}


                {core}
                {hasWarranty && (
                    <Box>
                        <Text size="xsmall" color={colorDarkSecondary} truncate>
                            {`${warrantyLabel}: $${warrantyPrice}${warrantyPriceEach}`}
                        </Text>
                    </Box>
                )}
            </>
            }

            <ItemTotalBox>
                <Text size="small" color={colorDarkSecondary}>
                    {'Item Total: '}
                </Text>
                <ItemTotalValue
                    size="small"
                    color={colorDarkSecondary}
                    weight={600}
                >
                    {` $${commaSeparetedValue(product.itemTotalAmount)}`}
                </ItemTotalValue>
            </ItemTotalBox>
        </>
    )
}

export default Information
